import { Chrome } from "lucide-react";

export default function GoogleButton({ label = "Continue with Google", testId = "google-signin-button" }) {
  const handleClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testId}
      className="inline-flex w-full items-center justify-center gap-3 rounded-md border-2 border-slate-300 bg-white px-6 py-2.5 text-sm font-medium text-slate-700 transition-colors duration-200 hover:border-blue-900 hover:text-blue-900"
    >
      <Chrome className="h-4 w-4" aria-hidden="true" />
      {label}
    </button>
  );
}
